import * as angularForms from '@angular/forms';

// global glue variable for externals
if (window['ng'] == null) window['ng'] = <any>{};

window['ng'].forms = angularForms;

export { angularForms };